import React from 'react';
import {
  IVendorVariantInternal,
} from '@models/VendorVariant/i-vendor-variant';
import Image from '@components/shared/images/atoms/Image/Image';
import formatCost from '@lib/formatCost';

import SelectedCheck from './SelectedCheck';
import styles from './ProductSelectCards.module.scss';

interface IProductSelectCardsProps {
  selectedVendorVariantId: number;
  vendorVariants: IVendorVariantInternal[];
  onSelect: (vendorVariantId: number) => void;
}

export default function ProductSelectCards({
  selectedVendorVariantId,
  vendorVariants,
  onSelect
}: IProductSelectCardsProps) {
  /* eslint-disable eqeqeq */
  const selectedVendorVariant = vendorVariants
    .find((vv) => vv.id == selectedVendorVariantId);
  return (
    <div className={ styles.ProductSelectCards }>
      <div className={ styles.ProductSelectCardsHeader }>
        <span className={styles.Title}>Product Results:&nbsp;&nbsp;</span>
        <span className={styles.Light}>{selectedVendorVariant?.title} ✨</span>
      </div>
      {vendorVariants.map((vv) => (
        <ProductSelectCard
          key={vv.id}
          isSelected={vv.id == selectedVendorVariantId}
          vendorVariant={vv}
          onClick={onSelect}
        />
      ))}
    </div>
  );
  /* eslint-enable eqeqeq */
}

interface IProductSelectCardProps {
  isSelected: boolean;
  vendorVariant: IVendorVariantInternal;
  onClick: (vendorVariantId: number) => void;
}

function ProductSelectCard({
  isSelected,
  vendorVariant,
  onClick
}: IProductSelectCardProps) {
  const inStock = vendorVariant.availability === 'in_stock';
  return (
    <button
      type="button"
      onClick={() => onClick(vendorVariant.id)}
      className={ `
        ${styles.ProductSelectCardButton}
        ${isSelected ? styles.Selected : ''}
        ${!inStock ? styles.OutOfStock : ''}
      ` }
    >
      <Image
        alt=""
        src={ vendorVariant.images?.[0]?.uri }
        className={ styles.ProductSelectCardImage }
        height={100}
      />
      <div className={styles.ProductSelectCardPrice}>
        {getStockStatusDisplay(vendorVariant)}
      </div>
      {isSelected ? <SelectedCheck className={ styles.SelectedCheck } /> : null}
    </button>
  );
}

function getStockStatusDisplay(vendorVariant: IVendorVariantInternal) {
  switch (vendorVariant.availability) {
    case 'in_stock': {
      return formatCost(vendorVariant?.salePrice?.price || vendorVariant?.retailPrice?.price || 0);
    }
    case 'back_ordered': {
      return 'Back Ordered';
    }
    case 'out_of_stock': {
      return 'Out of Stock';
    }
    default: {
      return formatCost(vendorVariant?.salePrice?.price || vendorVariant?.retailPrice?.price || 0);
    }
  }
}
